// extracted by mini-css-extract-plugin
export default {"container":"termsandconditions_container__FSGZW"};